import { ORGANISATION_UPLOAD_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(ORGANISATION_UPLOAD_ENDPOINT);
export default instance;
